// extracted by mini-css-extract-plugin
export default {"mainContainer":"SignUp_mainContainer__th3J0"};